/* Auto-generated. Do not edit manually. */
import { ReactComponent as Block_1_38 } from "../blocks/1/land_plot_block_38.svg";
import { ReactComponent as Block_1_39 } from "../blocks/1/land_plot_block_39.svg";
import { ReactComponent as Block_1_40 } from "../blocks/1/land_plot_block_40.svg";
import { ReactComponent as Block_1_41 } from "../blocks/1/land_plot_block_41.svg";
import { ReactComponent as Block_1_42 } from "../blocks/1/land_plot_block_42.svg";
import { ReactComponent as Block_1_43 } from "../blocks/1/land_plot_block_43.svg";
import { ReactComponent as Block_1_44 } from "../blocks/1/land_plot_block_44.svg";
import { ReactComponent as Block_1_45 } from "../blocks/1/land_plot_block_45.svg";
import { ReactComponent as Block_1_46 } from "../blocks/1/land_plot_block_46.svg";
import { ReactComponent as Block_1_47 } from "../blocks/1/land_plot_block_47.svg";
import { ReactComponent as Block_1_48 } from "../blocks/1/land_plot_block_48.svg";
import { ReactComponent as Block_1_49 } from "../blocks/1/land_plot_block_49.svg";
import { ReactComponent as Block_1_50 } from "../blocks/1/land_plot_block_50.svg";
import { ReactComponent as Block_1_51 } from "../blocks/1/land_plot_block_51.svg";
import { ReactComponent as Block_1_52 } from "../blocks/1/land_plot_block_52.svg";
import { ReactComponent as Block_1_53 } from "../blocks/1/land_plot_block_53.svg";
import { ReactComponent as Block_1_54 } from "../blocks/1/land_plot_block_54.svg";
import { ReactComponent as Block_1_55 } from "../blocks/1/land_plot_block_55.svg";
import { ReactComponent as Block_1_56 } from "../blocks/1/land_plot_block_56.svg";
import { ReactComponent as Block_1_57 } from "../blocks/1/land_plot_block_57.svg";
import { ReactComponent as Block_1_58 } from "../blocks/1/land_plot_block_58.svg";
import { ReactComponent as Block_1_59 } from "../blocks/1/land_plot_block_59.svg";
import { ReactComponent as Block_1_60 } from "../blocks/1/land_plot_block_60.svg";
import { ReactComponent as Block_1_61 } from "../blocks/1/land_plot_block_61.svg";
import { ReactComponent as Block_1_62 } from "../blocks/1/land_plot_block_62.svg";
import { ReactComponent as Block_1_63 } from "../blocks/1/land_plot_block_63.svg";
import { ReactComponent as Block_30_38 } from "../blocks/30/land_plot_block_38.svg";
import { ReactComponent as Block_30_39 } from "../blocks/30/land_plot_block_39.svg";
import { ReactComponent as Block_30_40 } from "../blocks/30/land_plot_block_40.svg";
import { ReactComponent as Block_30_41 } from "../blocks/30/land_plot_block_41.svg";
import { ReactComponent as Block_30_42 } from "../blocks/30/land_plot_block_42.svg";
import { ReactComponent as Block_30_43 } from "../blocks/30/land_plot_block_43.svg";
import { ReactComponent as Block_30_44 } from "../blocks/30/land_plot_block_44.svg";
import { ReactComponent as Block_30_45 } from "../blocks/30/land_plot_block_45.svg";
import { ReactComponent as Block_30_46 } from "../blocks/30/land_plot_block_46.svg";
import { ReactComponent as Block_30_47 } from "../blocks/30/land_plot_block_47.svg";
import { ReactComponent as Block_30_48 } from "../blocks/30/land_plot_block_48.svg";
import { ReactComponent as Block_30_49 } from "../blocks/30/land_plot_block_49.svg";
import { ReactComponent as Block_30_50 } from "../blocks/30/land_plot_block_50.svg";
import { ReactComponent as Block_30_51 } from "../blocks/30/land_plot_block_51.svg";
import { ReactComponent as Block_30_52 } from "../blocks/30/land_plot_block_52.svg";
import { ReactComponent as Block_30_53 } from "../blocks/30/land_plot_block_53.svg";
import { ReactComponent as Block_30_54 } from "../blocks/30/land_plot_block_54.svg";
import { ReactComponent as Block_30_55 } from "../blocks/30/land_plot_block_55.svg";
import { ReactComponent as Block_30_56 } from "../blocks/30/land_plot_block_56.svg";
import { ReactComponent as Block_30_57 } from "../blocks/30/land_plot_block_57.svg";
import { ReactComponent as Block_30_58 } from "../blocks/30/land_plot_block_58.svg";
import { ReactComponent as Block_30_59 } from "../blocks/30/land_plot_block_59.svg";
import { ReactComponent as Block_30_60 } from "../blocks/30/land_plot_block_60.svg";
import { ReactComponent as Block_30_61 } from "../blocks/30/land_plot_block_61.svg";
import { ReactComponent as Block_30_62 } from "../blocks/30/land_plot_block_62.svg";
import { ReactComponent as Block_30_63 } from "../blocks/30/land_plot_block_63.svg";
import { ReactComponent as Block_60_38 } from "../blocks/60/land_plot_block_38.svg";
import { ReactComponent as Block_60_39 } from "../blocks/60/land_plot_block_39.svg";
import { ReactComponent as Block_60_40 } from "../blocks/60/land_plot_block_40.svg";
import { ReactComponent as Block_60_41 } from "../blocks/60/land_plot_block_41.svg";
import { ReactComponent as Block_60_42 } from "../blocks/60/land_plot_block_42.svg";
import { ReactComponent as Block_60_43 } from "../blocks/60/land_plot_block_43.svg";
import { ReactComponent as Block_60_44 } from "../blocks/60/land_plot_block_44.svg";
import { ReactComponent as Block_60_45 } from "../blocks/60/land_plot_block_45.svg";
import { ReactComponent as Block_60_46 } from "../blocks/60/land_plot_block_46.svg";
import { ReactComponent as Block_60_47 } from "../blocks/60/land_plot_block_47.svg";
import { ReactComponent as Block_60_48 } from "../blocks/60/land_plot_block_48.svg";
import { ReactComponent as Block_60_49 } from "../blocks/60/land_plot_block_49.svg";
import { ReactComponent as Block_60_50 } from "../blocks/60/land_plot_block_50.svg";
import { ReactComponent as Block_60_51 } from "../blocks/60/land_plot_block_51.svg";
import { ReactComponent as Block_60_52 } from "../blocks/60/land_plot_block_52.svg";
import { ReactComponent as Block_60_53 } from "../blocks/60/land_plot_block_53.svg";
import { ReactComponent as Block_60_54 } from "../blocks/60/land_plot_block_54.svg";
import { ReactComponent as Block_60_55 } from "../blocks/60/land_plot_block_55.svg";
import { ReactComponent as Block_60_56 } from "../blocks/60/land_plot_block_56.svg";
import { ReactComponent as Block_60_57 } from "../blocks/60/land_plot_block_57.svg";
import { ReactComponent as Block_60_58 } from "../blocks/60/land_plot_block_58.svg";
import { ReactComponent as Block_60_59 } from "../blocks/60/land_plot_block_59.svg";
import { ReactComponent as Block_60_60 } from "../blocks/60/land_plot_block_60.svg";
import { ReactComponent as Block_60_61 } from "../blocks/60/land_plot_block_61.svg";
import { ReactComponent as Block_60_62 } from "../blocks/60/land_plot_block_62.svg";
import { ReactComponent as Block_60_63 } from "../blocks/60/land_plot_block_63.svg";
import { ReactComponent as Block_90_38 } from "../blocks/90/land_plot_block_38.svg";
import { ReactComponent as Block_90_39 } from "../blocks/90/land_plot_block_39.svg";
import { ReactComponent as Block_90_40 } from "../blocks/90/land_plot_block_40.svg";
import { ReactComponent as Block_90_41 } from "../blocks/90/land_plot_block_41.svg";
import { ReactComponent as Block_90_42 } from "../blocks/90/land_plot_block_42.svg";
import { ReactComponent as Block_90_43 } from "../blocks/90/land_plot_block_43.svg";
import { ReactComponent as Block_90_44 } from "../blocks/90/land_plot_block_44.svg";
import { ReactComponent as Block_90_45 } from "../blocks/90/land_plot_block_45.svg";
import { ReactComponent as Block_90_46 } from "../blocks/90/land_plot_block_46.svg";
import { ReactComponent as Block_90_47 } from "../blocks/90/land_plot_block_47.svg";
import { ReactComponent as Block_90_48 } from "../blocks/90/land_plot_block_48.svg";
import { ReactComponent as Block_90_49 } from "../blocks/90/land_plot_block_49.svg";
import { ReactComponent as Block_90_50 } from "../blocks/90/land_plot_block_50.svg";
import { ReactComponent as Block_90_51 } from "../blocks/90/land_plot_block_51.svg";
import { ReactComponent as Block_90_52 } from "../blocks/90/land_plot_block_52.svg";
import { ReactComponent as Block_90_53 } from "../blocks/90/land_plot_block_53.svg";
import { ReactComponent as Block_90_54 } from "../blocks/90/land_plot_block_54.svg";
import { ReactComponent as Block_90_55 } from "../blocks/90/land_plot_block_55.svg";
import { ReactComponent as Block_90_56 } from "../blocks/90/land_plot_block_56.svg";
import { ReactComponent as Block_90_57 } from "../blocks/90/land_plot_block_57.svg";
import { ReactComponent as Block_90_58 } from "../blocks/90/land_plot_block_58.svg";
import { ReactComponent as Block_90_59 } from "../blocks/90/land_plot_block_59.svg";
import { ReactComponent as Block_90_60 } from "../blocks/90/land_plot_block_60.svg";
import { ReactComponent as Block_90_61 } from "../blocks/90/land_plot_block_61.svg";
import { ReactComponent as Block_90_62 } from "../blocks/90/land_plot_block_62.svg";
import { ReactComponent as Block_90_63 } from "../blocks/90/land_plot_block_63.svg";

export const zone1_block_polygons = [
    {
        wrapperIndex: 2,
        areas: [
            {
                blockIndex: 38,
                Polygon: Block_1_38,
            },
            {
                blockIndex: 39,
                Polygon: Block_1_39,
            },
            {
                blockIndex: 40,
                Polygon: Block_1_40,
            },
            {
                blockIndex: 41,
                Polygon: Block_1_41,
            },
            {
                blockIndex: 42,
                Polygon: Block_1_42,
            },
            {
                blockIndex: 43,
                Polygon: Block_1_43,
            },
            {
                blockIndex: 44,
                Polygon: Block_1_44,
            },
            {
                blockIndex: 45,
                Polygon: Block_1_45,
            },
            {
                blockIndex: 46,
                Polygon: Block_1_46,
            },
            {
                blockIndex: 47,
                Polygon: Block_1_47,
            },
            {
                blockIndex: 48,
                Polygon: Block_1_48,
            },
            {
                blockIndex: 49,
                Polygon: Block_1_49,
            },
            {
                blockIndex: 50,
                Polygon: Block_1_50,
            },
            {
                blockIndex: 51,
                Polygon: Block_1_51,
            },
            {
                blockIndex: 52,
                Polygon: Block_1_52,
            },
            {
                blockIndex: 53,
                Polygon: Block_1_53,
            },
            {
                blockIndex: 54,
                Polygon: Block_1_54,
            },
            {
                blockIndex: 55,
                Polygon: Block_1_55,
            },
            {
                blockIndex: 56,
                Polygon: Block_1_56,
            },
            {
                blockIndex: 57,
                Polygon: Block_1_57,
            },
            {
                blockIndex: 58,
                Polygon: Block_1_58,
            },
            {
                blockIndex: 59,
                Polygon: Block_1_59,
            },
            {
                blockIndex: 60,
                Polygon: Block_1_60,
            },
            {
                blockIndex: 61,
                Polygon: Block_1_61,
            },
            {
                blockIndex: 62,
                Polygon: Block_1_62,
            },
            {
                blockIndex: 63,
                Polygon: Block_1_63,
            },
        ],
    },
    {
        wrapperIndex: 31,
        areas: [
            {
                blockIndex: 38,
                Polygon: Block_30_38,
            },
            {
                blockIndex: 39,
                Polygon: Block_30_39,
            },
            {
                blockIndex: 40,
                Polygon: Block_30_40,
            },
            {
                blockIndex: 41,
                Polygon: Block_30_41,
            },
            {
                blockIndex: 42,
                Polygon: Block_30_42,
            },
            {
                blockIndex: 43,
                Polygon: Block_30_43,
            },
            {
                blockIndex: 44,
                Polygon: Block_30_44,
            },
            {
                blockIndex: 45,
                Polygon: Block_30_45,
            },
            {
                blockIndex: 46,
                Polygon: Block_30_46,
            },
            {
                blockIndex: 47,
                Polygon: Block_30_47,
            },
            {
                blockIndex: 48,
                Polygon: Block_30_48,
            },
            {
                blockIndex: 49,
                Polygon: Block_30_49,
            },
            {
                blockIndex: 50,
                Polygon: Block_30_50,
            },
            {
                blockIndex: 51,
                Polygon: Block_30_51,
            },
            {
                blockIndex: 52,
                Polygon: Block_30_52,
            },
            {
                blockIndex: 53,
                Polygon: Block_30_53,
            },
            {
                blockIndex: 54,
                Polygon: Block_30_54,
            },
            {
                blockIndex: 55,
                Polygon: Block_30_55,
            },
            {
                blockIndex: 56,
                Polygon: Block_30_56,
            },
            {
                blockIndex: 57,
                Polygon: Block_30_57,
            },
            {
                blockIndex: 58,
                Polygon: Block_30_58,
            },
            {
                blockIndex: 59,
                Polygon: Block_30_59,
            },
            {
                blockIndex: 60,
                Polygon: Block_30_60,
            },
            {
                blockIndex: 61,
                Polygon: Block_30_61,
            },
            {
                blockIndex: 62,
                Polygon: Block_30_62,
            },
            {
                blockIndex: 63,
                Polygon: Block_30_63,
            },
        ],
    },
    {
        wrapperIndex: 61,
        areas: [
            {
                blockIndex: 38,
                Polygon: Block_60_38,
            },
            {
                blockIndex: 39,
                Polygon: Block_60_39,
            },
            {
                blockIndex: 40,
                Polygon: Block_60_40,
            },
            {
                blockIndex: 41,
                Polygon: Block_60_41,
            },
            {
                blockIndex: 42,
                Polygon: Block_60_42,
            },
            {
                blockIndex: 43,
                Polygon: Block_60_43,
            },
            {
                blockIndex: 44,
                Polygon: Block_60_44,
            },
            {
                blockIndex: 45,
                Polygon: Block_60_45,
            },
            {
                blockIndex: 46,
                Polygon: Block_60_46,
            },
            {
                blockIndex: 47,
                Polygon: Block_60_47,
            },
            {
                blockIndex: 48,
                Polygon: Block_60_48,
            },
            {
                blockIndex: 49,
                Polygon: Block_60_49,
            },
            {
                blockIndex: 50,
                Polygon: Block_60_50,
            },
            {
                blockIndex: 51,
                Polygon: Block_60_51,
            },
            {
                blockIndex: 52,
                Polygon: Block_60_52,
            },
            {
                blockIndex: 53,
                Polygon: Block_60_53,
            },
            {
                blockIndex: 54,
                Polygon: Block_60_54,
            },
            {
                blockIndex: 55,
                Polygon: Block_60_55,
            },
            {
                blockIndex: 56,
                Polygon: Block_60_56,
            },
            {
                blockIndex: 57,
                Polygon: Block_60_57,
            },
            {
                blockIndex: 58,
                Polygon: Block_60_58,
            },
            {
                blockIndex: 59,
                Polygon: Block_60_59,
            },
            {
                blockIndex: 60,
                Polygon: Block_60_60,
            },
            {
                blockIndex: 61,
                Polygon: Block_60_61,
            },
            {
                blockIndex: 62,
                Polygon: Block_60_62,
            },
            {
                blockIndex: 63,
                Polygon: Block_60_63,
            },
        ],
    },
    {
        wrapperIndex: 91,
        areas: [
            {
                blockIndex: 38,
                Polygon: Block_90_38,
            },
            {
                blockIndex: 39,
                Polygon: Block_90_39,
            },
            {
                blockIndex: 40,
                Polygon: Block_90_40,
            },
            {
                blockIndex: 41,
                Polygon: Block_90_41,
            },
            {
                blockIndex: 42,
                Polygon: Block_90_42,
            },
            {
                blockIndex: 43,
                Polygon: Block_90_43,
            },
            {
                blockIndex: 44,
                Polygon: Block_90_44,
            },
            {
                blockIndex: 45,
                Polygon: Block_90_45,
            },
            {
                blockIndex: 46,
                Polygon: Block_90_46,
            },
            {
                blockIndex: 47,
                Polygon: Block_90_47,
            },
            {
                blockIndex: 48,
                Polygon: Block_90_48,
            },
            {
                blockIndex: 49,
                Polygon: Block_90_49,
            },
            {
                blockIndex: 50,
                Polygon: Block_90_50,
            },
            {
                blockIndex: 51,
                Polygon: Block_90_51,
            },
            {
                blockIndex: 52,
                Polygon: Block_90_52,
            },
            {
                blockIndex: 53,
                Polygon: Block_90_53,
            },
            {
                blockIndex: 54,
                Polygon: Block_90_54,
            },
            {
                blockIndex: 55,
                Polygon: Block_90_55,
            },
            {
                blockIndex: 56,
                Polygon: Block_90_56,
            },
            {
                blockIndex: 57,
                Polygon: Block_90_57,
            },
            {
                blockIndex: 58,
                Polygon: Block_90_58,
            },
            {
                blockIndex: 59,
                Polygon: Block_90_59,
            },
            {
                blockIndex: 60,
                Polygon: Block_90_60,
            },
            {
                blockIndex: 61,
                Polygon: Block_90_61,
            },
            {
                blockIndex: 62,
                Polygon: Block_90_62,
            },
            {
                blockIndex: 63,
                Polygon: Block_90_63,
            },
        ],
    },
];